<template>
  <div class="carousel">
    <div class="carouseTitle fontYaHei clearfix">
      <div class="left">{{ title }} <a href="javascript:;" class="more" @click="$emit('showSign')">查看全部</a>
      </div>
      <div class="right">
        <template v-if="page===0">
          <a href="javascript:void(0)" class="jcarousel-control-prev inactive"></a>
          <a href="javascript:void(0)" class="jcarousel-control-next" @click="togglePage(1)"></a>
        </template>
        <template v-else>
          <a href="javascript:void(0)" class="jcarousel-control-prev" @click="togglePage(0)"></a>
          <a href="javascript:void(0)" class="jcarousel-control-next inactive"></a>
        </template>
      </div>
    </div>
    <div class="divider"></div>
    <div class="carouselBox" >
      <transition-group :name="animationName" tag="ul" class="clearfix" ref="hot">
        <li v-show="page === index" class="radio_list" v-for="(item, index) in musicList" :key="index">
          <div class="radio_list_item" v-for="(music, i) in item" :key="i" @click.stop="$emit('play', music)">
            <a href="javascript:;" class="radioCover" rel="nofollow">
              <img :alt="music.name" :src="music.coverUrl">
              <!--<span class="radioBand bold">FM<i>813253</i></span> <span class="radioBandBg"></span>-->
            </a>
            <p class="radioName fontYaHei">
              <a href="javascript:;" rel="nofollow">{{ music.singer }}</a>
            </p>
            <p class="radio-last-audio fontYaHei js-play-data">
              <span></span>
              <a href="javascript:;">{{ music.name }}</a>
            </p>
          </div>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        title: String,
        page: {
          type: Number,
          default: 0
        },
        musicList: Array,
        animationName: String
      },
      methods: {
        togglePage(page) {
          this.$emit('togglePage', page);
        }
      }
    }
</script>

<style scoped lang="less">
  .left-enter-active,
  .right-enter-active {
    transform: translateX(0);
    transition: all .6s ease;
  }
  .left-leave-active {
    transform: translateX(100%);
    transition: all .6s ease;
  }
  .left-enter {
    transform: translateX(-100%);
  }
  .left-leave,
  .right-leave {
    transform: translateX(0);
  }
  .right-leave-active {
    transform: translateX(-100%);
    transition: all .6s ease;
  }
  .right-enter {
    transform: translateX(100%);
  }

  .carousel{
    padding-top: 20px;
  }
  .carouseTitle, .recommendTitle {
    position: relative;
    height: 28px;
    font-size: 20px;
    line-height: 1.4;
    color: #66625b;
    padding: 0 0 35px 2px;
  }
  .carouseTitle .left a{
    color: #736c5c;
    font-size: 13px;
    margin-left: 15px;
    background: url(../assets/crumbsArrow.png) no-repeat right 10px;
    padding-right: 15px;
    margin-right: 7px;
    &:hover{
      color: #f7bd44;
    }
  }
  a:link, a:visited, a:focus {
    outline: medium none;
    text-decoration: none;
  }

  .carouselBox{
    padding: 16px 0 28px 0;
    overflow: hidden;
  }
  .carouselBox ul{
    position: relative;
    height: 220px;
    overflow: hidden;
  }
  .carouselBox li{
    position: absolute;
    color: #867f6f;
    font-size: 14px;
  }
  .carouselBox .radioCover{
    position: relative;
    height: 140px;
    display: block;
    overflow: hidden;
  }
  .carouselBox .radioCover img{
    width:140px;
  }
  .carouselBox .radioBand{
    color: #fff;
    font-family: arial,helvetica;
    position: absolute;
    left: 11px;
    bottom:3px;
    z-index: 2;
    font-size: 14px;
  }
  .carouselBox .radioBand i{
    font-style: normal;
    padding-left:2px;
  }
  .carouselBox .radioBandBg{
    background-color: #000;
    border-width: 0;
    opacity: 0.5;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height:26px;
  }
  .carouselBox .radio-last-audio {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #a39f8d;
  }
  .carouselBox .radio-last-audio span {
    cursor: pointer;
    background: url(../assets/addon-1.png) no-repeat -74px -6px;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }
  .radio_list{
    display: flex;
    flex-direction: row;
    .radio_list_item{
      width: 140px;
      margin-right: 30px;
    }
    .radioName{
      margin:10px 0 5px;
      a{
        color:#867f6f;
      }
    }
    .radioAuthor{
      a{
        color: #a49d8c;
      }
      margin-bottom:10px;
    }
    .radio-last-audio{
      a{
        color: #a49d8c;
      }
    }
    a:hover{
      text-decoration: underline;
    }
  }
  .jcarousel-control-prev,
  .jcarousel-control-prev.inactive,
  .jcarousel-control-next,
  .jcarousel-control-next.inactive{
    background: url(../assets/siteIcon.png) no-repeat 0 -30px;
    width: 28px;
    height: 28px;
    display: inline-block;
  }
  .jcarousel-control-prev:hover{
    background-position: 0 -60px;
  }
  .jcarousel-control-prev:active{
    background-position: -80px -90px;
  }
  .jcarousel-control-prev.inactive,
  .jcarousel-control-prev.inactive:hover{
    background-position: 0 0;
    cursor: default;
  }
  .jcarousel-control-next{
    background-position: -30px -30px;
    margin-left: 12px;
  }
  .jcarousel-control-next:hover{
    background-position: -30px -60px;
  }
  .jcarousel-control-next:active{
    background-position: -80px -120px;
  }
  .jcarousel-control-next.inactive,
  .jcarousel-control-next.inactive:hover{
    background-position:-30px 0px;
    cursor: default;
  }
</style>
